

function ScorecardAdminController(ScorecardService, program) {
    this.createScorecard = ScorecardService.createScorecard.bind(ScorecardService, program);
    this.resetScorecard = ScorecardService.resetScorecard.bind(ScorecardService, program);
    this.deleteScorecard = ScorecardService.deleteScorecard.bind(ScorecardService, program);
}


module.controller('ScorecardAdminController', ScorecardAdminController);
